import { Pagination, PaginationResponse } from '@ekkogmbh/apisdk';

export const injectFakePagination = <T>(data: T[], pagination?: Pagination): PaginationResponse<T> => {
  const count = data.length;
  const limit = pagination?.limit ?? count;
  const page = pagination?.page ?? 1;
  const pageCount = Math.ceil(count / limit);

  const startIdx = (page - 1) * limit;
  const endIdx = startIdx + limit;
  const pageChunk = data.slice(startIdx, endIdx < count ? endIdx : undefined);

  return {
    currentPage: page,
    items: pageChunk,
    pageCount,
    itemsPerPage: limit,
    totalItemCount: count,
  };
};
